export default "__VITE_ASSET__GxGMb7Zl__"